module.exports = "/_next/static/images/game2-background-75007c2ff846fd502d11c6c736cfd9d9.jpg";